// extracted by mini-css-extract-plugin
module.exports = {"customLoader":"CssLoader_customLoader__1Ayyi","load4":"CssLoader_load4__1ZaSx"};